import React from 'react';

import { withToolbarContext } from './../../../../ricos-context';

import type { ToolbarItemProps } from '../../../types';
import { ToolbarButton } from '../ToolbarButton';

const TitleButton = ({ toolbarItem, context, dataHook }: ToolbarItemProps) => {
  const { isMobile, t, getPublicCommands } = context || {};
  const publicCommands = getPublicCommands?.();
  const onClick = () => toolbarItem.commands?.click();
  const tooltip = t?.(toolbarItem.presentation?.tooltip);

  return (
    <ToolbarButton
      isMobile={isMobile}
      disabled={toolbarItem.attributes.disabled}
      active={toolbarItem.attributes.active}
      tooltip={tooltip}
      onClick={onClick}
      icon={toolbarItem.presentation?.getIcon(publicCommands)}
      dataHook={dataHook}
    />
  );
};

export default withToolbarContext(TitleButton);
